import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "unavailable" }
const _hoisted_2 = { class: "unavailable-card" }


export default /*@__PURE__*/_defineComponent({
  __name: 'UnavailableView',
  props: {
    title: { default: 'Indisponível nesta fase' },
    reason: { default: 'O Chatwoot saiu de circulação e esta tela ainda depende de dados que só existiam lá. ' +
    'Fica de fora até o WootDash ter um equivalente de verdade.' }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "1.6",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, [
        _createElementVNode("circle", {
          cx: "12",
          cy: "12",
          r: "10"
        }),
        _createElementVNode("line", {
          x1: "12",
          y1: "8",
          x2: "12",
          y2: "12"
        }),
        _createElementVNode("line", {
          x1: "12",
          y1: "16",
          x2: "12.01",
          y2: "16"
        })
      ], -1)),
      _createElementVNode("h2", null, _toDisplayString(__props.title), 1),
      _createElementVNode("p", null, _toDisplayString(__props.reason), 1),
      _cache[1] || (_cache[1] = _createElementVNode("p", { class: "unavailable-plan" }, " Esta tela volta assim que o WootDash tiver o equivalente. ", -1))
    ])
  ]))
}
}

})